import { get } from "lodash";

import { FilterField } from "~/features/filter";
import {
  DealersLocationItem,
  useGetDealersLocationItemQuery,
} from "~/schemas/generated/graphql";

type Translate = (key: string) => string;

/**
 * Опции мультиселекта городов: справочник DealerGetter.getDealersLocationItem,
 * ветка items/itemsEn выбирается по языку интерфейса из localStorage
 * (как в старом FilterGIBDD).
 */
const useCityOptions = () => {
  const isEn = localStorage.getItem("language") === "en";

  const { data, loading } = useGetDealersLocationItemQuery({
    variables: { item: DealersLocationItem["City"] },
  });

  const options = get(
    data,
    `DealerGetter.getDealersLocationItem.${isEn ? "itemsEn" : "items"}`,
    [],
  ).map((el: string) => ({ label: el, value: el }));

  return { options, loading };
};

/**
 * Поля фильтра страницы ГИБДД: id и vin — текстовые поля,
 * диапазон дат регистрации, мультиселект городов.
 * Значения хранятся в URL (см. ~/features/filter).
 */
export const gibddFilterFields = (t: Translate): FilterField[] => [
  {
    name: "id",
    type: "input",
    label: t("gibdd.id"),
  },
  {
    name: "vin",
    type: "input",
    label: t("gibdd.vin"),
  },
  {
    name: "city",
    type: "select",
    multiple: true,
    label: t("srr.CityGroup"),
    optionsHook: useCityOptions,
  },
  {
    name: "dateRegistrationStart",
    nameTo: "dateRegistrationEnd",
    type: "dateRange",
    label: t("gibdd.dateRegistration"),
    placeholder: t("pkd.data_begin"),
    placeholderTo: t("pkd.data_end"),
    fixedWidth: 360,
    disableFutureDates: true,
  },
];
